<div class="curtain">

<section  class="component-modalDialog redesigned size-6" id="test-addOrEditDocumentDialog">
    <header>
        Nahrát dokument
        <a class="closeModalDialog fa fa-close" (click)="closeModal()"></a>
    </header>
    <div class="contentContainer overrideHeaderPadding scrollable nativeScrollbar inside" >
        <ca-loading  [loadState]="loading">
        <div *ngIf="!loading">

            <div class="col-6" *ngIf="task !== 'barter' && task !== 'purchase' && task !== 'parcel' && task !== 'building'
                && task !== 'subject'">
                <input
                    type="radio"
                    class="styled"
                    name="document-type"
                    id="document-type-contract"
                    [(ngModel)]="documentType"
                    value="contract">
                <label for="document-type-contract" class="showAsCheckbox withLabel">běžný dokument</label>
                <input
                    type="radio"
                    class="styled"
                    name="document-type"
                    id="document-type-scanned"
                    [(ngModel)]="documentType"
                    value="scanned">
                <label for="document-type-scanned" class="showAsCheckbox withLabel">naskenovaný dokument</label>
            </div>

            <div>
                <div class="col-4">
                    <label for="file-upload" class="component-fileButton_label">vybrat soubor dokumentu</label>
                    <input
                        type="text"
                        [(ngModel)]="filename"
                        class="component-fileButton_field"
                        placeholder="Soubor nevybrán"
                        disabled>
                </div>
                <div class="col-2">
                    <ca-document-upload
                            title="Vybrat soubor"
                            boxButton="false"
                            (fileSelected)="selectFile($event)"
                            [viewMode]="viewMode">
                    </ca-document-upload>
                </div>

            </div>

            <div *ngIf="documentType === 'scanned'">
                <ca-attachment-type-scan-data [mode]="mode" [task]="task"></ca-attachment-type-scan-data>
            </div>
        </div>
        </ca-loading>
    </div>

    <footer *ngIf="!loading">
        <a class="button-primary" (click)="saveFile()">Uložit</a>
        <a class="button-secondary" (click)="closeModal(null)">Storno</a>
    </footer>

</section>

</div><!-- curtain -->